<!--
 * @Description: 市场行情模块
-->
<template>
    <div :class="$style['m-market']" style="overflow: hidden;">
        <div class="m-container">
            <div :class="$style['container-inner']">
                <div ref="listWrapper" :class="$style['price-list']" @pointerenter="pause" @pointerleave="play">
                    <div ref="listBox" :class="$style['list-inner']" class="flex">
                        <a v-for="(item, index) in runList" :key="index" :class="$style['list-item']" :href="item.link" target="_blank">
                            <div :class="$style['item-title']">
                                <div class="text">{{
                  `${decodeURI(item.symbol)} $${item.recentQuotation}(${item.change})`
                }}</div>
                                <UeIcon :class="$style['ic']" name="long-arrow-right" />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mitt from 'mitt'
import { mapGetters } from 'vuex'
import { gsap } from '../../../utils/gsap'
import _debounce from 'lodash/debounce'
import _isEqual from 'lodash/isEqual'

// const priceList = [
//   { title: "BTC $26,263.60 (+0.08%)", link: "/" },
//   { title: "ETH $1,589.70 (+0.32%)", link: "/" },
//   { title: "XRP $0.50 (+0.08%)", link: "/" },
//   { title: "LTC $64.43 (-0.39%)", link: "/" },
//   { title: "BCH $213.25 (+0.48%)", link: "/" }
// ];

const mittManage = mitt()
export default {
    props: {
        marketList: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            flag: true,
            // listWrapper,
            // listBox
        }
    },
    created() {
        console.log(this.isDirection, 'isDirection')
    },
    watch: {
        marketList(newVal, oldVal) {
            console.log('更新', 123);
            if (!_isEqual(newVal, oldVal) && this.flag) {
                this.flag = false
                this.createLoopAnimate()
            }
            
        },
    },
    computed: {
        runList() {
            let a = this.marketList.map((i) => ({
                ...i,
                symbol:
                    (i.symbol && i.symbol.split('_')[0].toUpperCase()) || '',
                change: i.change > 0 ? `+${i.change}` : i.change,
            }))
            return a.concat(a)
        },
        ...mapGetters(['isDirection']),
    },

    methods: {
        createLoopAnimate() {
            
            const listWrapper = this.$refs.listWrapper
            const listBox = this.$refs.listBox
            if (!listWrapper || !listBox) return
            const dis = listBox.scrollWidth / 1
            const stepDuration = 50
            const ctrl = gsap
                .to(listBox, {
                    duration: (dis - listBox.clientWidth) / stepDuration,
                    ease: 'none',
                    x: () => {
                        return '-' + (dis - listBox.clientWidth)
                        // return '-=' + dis
                    },
                    onComplete: () => {
                        gsap
                        .to(listBox, {
                            duration: 0,
                            ease: 'none',
                            x: () => {
                                return 0
                                // return '-=' + dis
                            },
                            onComplete: () => {
                                this.createLoopAnimate()
                            }
                        })
                    }
                })
            mittManage.on('play', () => {
                ctrl.play()
            })
            mittManage.on('pause', () => {
                ctrl.pause()
            })
            mittManage.on('winResize', () => {
                ctrl.invalidate()
            })
            mittManage.on('destroy', () => {
                ctrl.kill()
            })
        },
        play() {
            mittManage.emit('play')
        },
        pause() {
            mittManage.emit('pause')
        },
    },

    mounted() {
        this.createLoopAnimate()

        const winResizeWatch = _debounce(() => {
            mittManage.emit('winResize')
        }, 200)
        mittManage.on('destroy', () => {
            $(window).off('resize', winResizeWatch)
        })

        $(window).on('resize', winResizeWatch)
    },

    beforeDestroy() {
        mittManage.emit('destroy')
        mittManage.all.clear()
    },
}
</script>
<style lang="scss" module>
.m-market {
    --g--container-width: 100%;
    --g--container-space: 0;
    .container-inner {
        // background: linear-gradient(90deg, #ff7272 0%, #fcc73e 200%) !important;
        // background-image: linear-gradient(90deg, rgb(156, 0, 0) 0%, rgb(144, 104, 2) 200%);
        background: linear-gradient(
            90deg,
            #ff7b6d 0%,
            #fcc73e 62.5%,
            #a667b6 100%
        );
        background-color: initial;
    }
    .price-list {
        .item-title {
            position: relative;
            color: #ffffff;
            span{
                
            }
        }
        .list-item {
            font-size: 30px;
            font-weight: 800;
            line-height: 106%; /* 31.8px */

            position: relative;

            width: fit-content;
            padding: 35px 30px;

            white-space: nowrap;
            .ic {
                position: absolute;
                top: 50%;
                left: calc(100% + 8px);

                transition: 0.26s ease;
                transform: translateY(-50%) rotate(-15deg);

                opacity: 0;
            }
            &:hover {
                .ic {
                    transform: translateY(-50%) rotate(-45deg);

                    opacity: 1;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/compontents/newHome/index/MarketModule.vue